import IconButton from "@mui/material/IconButton";
import Bookmark from "assets/bookmark.png";
import Bookmarked from "assets/bookmarked.png";
import { useAppSelector } from "redux/hooks";
import ToolTip from "../Tooltip";

interface Props {
  item: any;
  setBookmarked: any;
  bookmarked: any;
}

export default function BookmarkInncode(props: Props) {
  const { item, bookmarked, setBookmarked } = props;

  const propertyInfo = useAppSelector((state) => state.filters.propertyList);
  const searchedInncodes = useAppSelector((state) => state.filters.searchedInncodes);

  const isBookmarked = bookmarked?.find(
    (bookmarkedPropertyInfo: any) => bookmarkedPropertyInfo?.innCode === item.innCode
  );

  const handleBookmarking = () => {
    let finalBookmarkList = bookmarked;
    if (isBookmarked) {
      finalBookmarkList = bookmarked.filter((curr: any) => curr.innCode !== item.innCode);
    } else {
      const bookmarkedInncodeDetails = [...searchedInncodes, ...propertyInfo].find(
        (bookmarkedPropertyInfo: any) => bookmarkedPropertyInfo.innCode === item.innCode
      );
      finalBookmarkList = [...bookmarked, bookmarkedInncodeDetails];
    }
    setBookmarked(finalBookmarkList);
  };

  return (
    <ToolTip title={isBookmarked ? "Remove Bookmark" : "Bookmark this Inncode"}>
      <IconButton
        sx={{ p: 0, ml: "auto" }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleBookmarking();
        }}
      >
        <img src={isBookmarked ? Bookmarked : Bookmark} alt="sample" height="23" width="23" />
      </IconButton>
    </ToolTip>
  );
}
